import { Note, User, useShareNoteMutation, useUnshareNoteMutation } from '@treams/treams-network';

export function useShareNote(note: Pick<Note, 'id'>) {
	const [share, { error: shareError }] = useShareNoteMutation();
	const [unshare, { error: unshareError }] = useUnshareNoteMutation();

	const shareNote = async (user: Pick<User, 'id'>) => {
		try {
			return await share({
				variables: {
					input: {
						noteID: note.id,
						userID: user.id,
					},
				},
			});
		} catch {
			return false;
		}
	};

	const unshareNote = async (user: Pick<User, 'id'>) => {
		try {
			return await unshare({
				variables: {
					input: {
						noteID: note.id,
						userID: user.id,
					},
				},
			});
		} catch {
			return false;
		}
	};

	return {
		shareNote,
		unshareNote,
		error: shareError?.graphQLErrors[0] ?? unshareError?.graphQLErrors[0],
	};
}
